import { useCallback } from 'react'

import { FormChangedHandler, useFormData } from 'brief-form'

import { FormPaths } from '../../enums'
import { useSyncFormData } from '../../hooks'
import { useValidateFormPersist } from '../../hooks/useValidateFormPersist'
import { LicenseDetailsChangeHandler, LicenseDetailsFormData, LicenseDetailsFormValue } from '../../types/forms'

export const useLicenseDetailsForm = ({
  licenseIndex,
  companyIndex,
  formData,
  onChange
}: {
  licenseIndex: number
  companyIndex: number
  formData: LicenseDetailsFormData
  onChange: LicenseDetailsChangeHandler
}) => {
  const onFormChanged: FormChangedHandler<LicenseDetailsFormValue> = useCallback(
    (formValues, formErrors) => onChange({ companyIndex, formData: { formValues, formErrors }, licenseIndex }),
    [onChange, licenseIndex, companyIndex]
  )

  const { config, Field, set, validate } = useFormData<LicenseDetailsFormValue>({
    onFormChanged,
    initialValue: formData.formValues,
    initialErrors: formData.formErrors
  })

  useSyncFormData({ set, formData })
  const formKey = `${FormPaths.LICENSE_DETAILS}-${companyIndex}-${licenseIndex}`
  useValidateFormPersist<LicenseDetailsFormValue>({
    formName: formKey,
    validate,
    config
  })

  return { Field, config }
}
